/**
 * Hierarchy Map Utility Functions and Types
 *
 * Shared types and utilities for hierarchy map overlays.
 * Separated from component file to support Fast Refresh.
 */

import type { GeoLocation } from '@/lib/types'
import type { ExtendedSectorInfo } from '@/hooks/useHierarchy'

export interface SectorMapOverlay {
  roomId: string
  name: string
  center: GeoLocation
  radiusMeters: number
  status: 'active' | 'offline' | 'alert' | 'moving'
  participantCount: number
  participantCentroid?: GeoLocation
  color?: string
}

export function convertToSectorMapOverlay(sector: ExtendedSectorInfo): SectorMapOverlay | null {
  if (sector.centerLat === undefined || sector.centerLng === undefined || !sector.radiusMeters) {
    return null
  }

  return {
    roomId: sector.roomId,
    name: sector.name,
    center: {
      latitude: sector.centerLat,
      longitude: sector.centerLng,
    },
    radiusMeters: sector.radiusMeters,
    status: sector.status as 'active' | 'offline' | 'alert' | 'moving',
    participantCount: sector.participantCount,
    participantCentroid:
      sector.participantCentroidLat !== undefined && sector.participantCentroidLng !== undefined
        ? {
            latitude: sector.participantCentroidLat,
            longitude: sector.participantCentroidLng,
          }
        : undefined,
  }
}

export function convertSectorsToMapOverlays(sectors: ExtendedSectorInfo[]): SectorMapOverlay[] {
  return sectors
    .map(convertToSectorMapOverlay)
    .filter((s): s is SectorMapOverlay => s !== null)
}
